import { useTheme } from "styled-components";
import EntityTranslationsContainer from "../../../../../../components/entityTranslationsContainer/EntityTranslationsContainer";
import InputWrapper from "../../../../../../components/input/wrapper/InputWrapper";
import { useLanguageContext } from "../../../../../../context/LanguageContext";
import { StyledInput } from "../../../../../../styles/InputStyles";
import { StyledFlexColumn } from "../../../../../../styles/LayoutStyles";
import FontForm from "../default/font/FontForm";
import PositionForm from "../default/position/PositionForm";
import SizeForm from "../default/size/SizeForm";

function TextFormView({
  setPrinterData,
  selectedLabelItem,
  selectedLabelItemIndex,
  translationsController,
  submitError,
}) {
  const theme = useTheme();
  const { translate } = useLanguageContext();

  return (
    <StyledFlexColumn>
      {/* X & Y */}
      <PositionForm
        setPrinterData={setPrinterData}
        selectedLabelItem={selectedLabelItem}
        selectedLabelItemIndex={selectedLabelItemIndex}
        submitError={submitError}
      />

      {/* Width & Height */}
      <SizeForm
        setPrinterData={setPrinterData}
        selectedLabelItem={selectedLabelItem}
        selectedLabelItemIndex={selectedLabelItemIndex}
        submitError={submitError}
      />

      {/* Font */}
      <FontForm
        setPrinterData={setPrinterData}
        selectedLabelItem={selectedLabelItem}
        selectedLabelItemIndex={selectedLabelItemIndex}
        submitError={submitError}
      />

      <EntityTranslationsContainer
        controller={translationsController}
        style={{ marginTop: theme.spacing.large }}
      >
        <InputWrapper
          label={translate("eva.main.validation.attributes.label_items.*.text")}
          required
          error={translationsController.getTranslationError(
            "text",
            submitError
          )}
        >
          <StyledInput
            as={"textarea"}
            type="text"
            value={translationsController.getValue("text")}
            onChange={(e) =>
              translationsController.onTranslationChange(e.target.value, "text")
            }
          />
        </InputWrapper>
      </EntityTranslationsContainer>
    </StyledFlexColumn>
  );
}

export default TextFormView;
